import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PAGES from "../seo-pages.json";

const DEFAULT = PAGES["/"];

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const setPageMeta = ({ title, description, image }) => {
  document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", window.location.href);
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  const img = image || `${window.location.origin}/og-image.jpg`;
  upsertMeta("property", "og:image", img);
  upsertMeta("name", "twitter:image", img);
};

export const usePageMeta = (meta) => {
  const { title, description, image } = meta || {};
  useEffect(() => {
    if (title) setPageMeta({ title, description, image });
  }, [title, description, image]);
};

export const RouteMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/evento/")) return;
    setPageMeta(PAGES[pathname] || { ...DEFAULT, title: DEFAULT.title });
  }, [pathname]);
  return null;
};
